import React, { useState, useEffect } from "react";

import './Confirmation.css';

import { SetModalState, RegisterModalData, RegisterModalObserver, SetModalData } from "interface/PopUp";

import { Reg_CopyGenerator, Reg_Delete } from "services/RegisterData";

import { GetUserData, RegisterUserData } from "interface/Users";
import { SvgClose } from "components/SvgFile";

export default function PopUP_Confirmation(){

    const [ loading, setLoading ]     = useState(false);
    const [ modalData, setModaldata ] = useState({});
    const [ showPopUp, setShowPopUp ] = useState(false);
    const [ userId, setUserId ]       = useState(GetUserData('id'));

    const [ type, setType ]             = useState(0);
    const [ idioma, setIdioma ]         = useState('');
    const [ copyIdioma, setCopyIdioma ] = useState('');

    useEffect(()=>{
        RegisterUserData('id', setUserId);

        RegisterModalData('Confirmation', setModaldata);
        RegisterModalObserver('Confirmation', setShowPopUp);
    }, []);

    useEffect(()=>{
        if(showPopUp == true){
            modalData.type == 'duplicate' ? setType(1) : setType(0);
            modalData.type == 'duplicate' ? setIdioma(modalData.idioma) : setIdioma('en');
        }
    }, [showPopUp]);

    function TypeAlt(){
        switch (modalData.type) {
            case "update_json": case "duplicate":
                break;

            default:
                    Reg_Delete(userId, modalData.id, modalData.origin, modalData.type, ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
                break;
        }
        SetModalState('Confirmation', false);
    }

    function DuplicateData(){
        setLoading(true);
        Reg_CopyGenerator(modalData.origin, userId, modalData.id, idioma, copyIdioma, ()=>{ CallbackSuccess() }, ()=>{ CallbackError() });
    }

    function CallbackSuccess(){
        SetModalData('ReturnResponse', { "page": "ok" });
        SetModalState('ReturnResponse', true);
    }

    function CallbackError(){
        SetModalData('ReturnResponse', { "page": "erro" });
        SetModalState('ReturnResponse', true);
    }

    function ClosePopUp(){
        SetModalState('Confirmation', false);
    }

    function TypeRemoval(){
        switch(modalData.type){
            case "update_json":
                return "Update website";
            case "disabled_access_dash":
                return (
                    <div>
                        Deactivate user:
                        <div>{ modalData.name }</div>
                    </div>
                );
            case "reactivate_access_dash":
                return (
                    <div>
                        Reactivate user:
                        <div>{ modalData.name }</div>
                    </div>
                );
            default:
                return (
                    <div>
                        Delete:
                        <div>{ modalData.name }</div>
                    </div>
                );
        }
    }

    return (
        (showPopUp ?
            <>
                <div className={ loading == true ? "return_data_save div_loading" : "return_data_save" }>
                    <img alt="loading" src="./assets/loading.gif" className="loading" />
                </div>
                <div className="PopUp">
                    <div className="all Confirmation">
                        {
                            type == 0 ?
                            <div className="div_data">
                                <div className="title">
                                    { TypeRemoval() }
                                </div>
                            </div> :
                            <div className="div_data type_div">
                                <div className="title">
                                    DUPLICATE DATA
                                </div>
                                <div className="close" onClick={ ()=>{ ClosePopUp(); } }>
                                    <SvgClose color="#F00000" className="icons" />
                                </div>
                            </div>
                        } 

                        <div className="div_data" style={ { paddingTop: 0 } }>                           
                            {
                                type == 0 ?
                                <div className="content div_confirmation">
                                    <div onClick={ ()=>{ TypeAlt(); } }>
                                        <div className="opt_select yes_update">Yes</div>
                                    </div>
                                    <div onClick={ ()=>{ ClosePopUp(); } }>
                                        <div className="opt_select not_update">No</div>
                                    </div>
                                </div> :
                                <div className="content">
                                    <div className="text_inf">Choose which language you want to copy from</div>
                                    <div className="content div_confirmation">
                                        {
                                            idioma == 'en' ? null : 
                                            <div className="" onClick={ ()=>{ setCopyIdioma('en') } }>
                                                <div className={ copyIdioma == 'en' ? "opt_select select_idioma yes_update" : "opt_select select_idioma" }>English</div>
                                            </div>
                                        }
                                        {
                                            idioma == 'es' ? null : 
                                            <div className="" onClick={ ()=>{ setCopyIdioma('es') } }>
                                                <div className={ copyIdioma == 'es' ? "opt_select select_idioma yes_update" : "opt_select select_idioma" }>Spanish</div>
                                            </div>
                                        }
                                    </div>
                                    
                                    {
                                        copyIdioma == "" ? "To generate a copy it is necessary to choose a language" : <div className="new_block_text" onClick={ ()=>{ DuplicateData() } }>To save</div>
                                    }

                                </div>
                            }
                        </div>
                    </div>
                </div>
            </>
        : <React.Fragment></React.Fragment>)
    );
}
